import React from "react";

import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import { SidebarBranding } from "./SidebarBranding";

const useStyles = makeStyles(theme => ({
  root: {
    width: theme.spacing(9),
  },
  drawerOpen: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    width: theme.spacing(30),
    height: "100vh",
  },
  drawerClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(9),
    height: "100vh",
  },
}));

interface DesktopSideBarProps {
  ContentElement: React.ElementType;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onAfterCloseSidebar: () => void;
  isBrandingVisible?: boolean;
  isHashModalOpen?: boolean;
}

export const DesktopSideBar = ({
  ContentElement,
  isOpen,
  setIsOpen,
  isBrandingVisible = true,
  onAfterCloseSidebar,
  isHashModalOpen,
}: DesktopSideBarProps) => {
  const classes = useStyles();

  const handleDrawerClose = () => {
    setIsOpen?.(false);
    onAfterCloseSidebar?.();
  };

  const toggleSidebar = () => (isOpen ? handleDrawerClose() : setIsOpen(true));

  return (
    <Drawer
      className={classes.root}
      variant="permanent"
      style={{
        // check if hash modal is open because the sidebar needs to be below modals when they are open otherwise sit above them.
        // because drop downs zindex are explicitly set to sit above hash modals and they render over the sidebar without this.
        zIndex: isHashModalOpen ? 1200 : 2500,
      }}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: isOpen,
          [classes.drawerClose]: !isOpen,
        }),
      }}
      open={isOpen}
    >
      {isBrandingVisible && <SidebarBranding isOpen={isOpen} />}
      {ContentElement && (
        <ContentElement
          closeSidebar={handleDrawerClose}
          toggleSidebar={toggleSidebar}
          isOpen={isOpen}
        />
      )}
    </Drawer>
  );
};
